import { HomePageBehavior } from '../tailwind_page_behavior/HomePageBehavior';
import '../tailwind_landing_page_v4/styles.scss';

require.context('../../assets/images/applicants', true);

document.addEventListener('DOMContentLoaded', () => {
  /**
   * @instance HomePageBehavior
   */
  const homePageApp = new HomePageBehavior();

  homePageApp.navMenuBehavior();
  homePageApp.heroFormBehavior();
  homePageApp.carouselBehavior();
  homePageApp.faqBehavior();
  homePageApp.textMeFormBehavior();
  homePageApp.updateDownloadAppUrl();
});
